import React from 'react';

interface VideoLinkProps {
  videoId: string;
}
const VideoLink: React.FC<VideoLinkProps> = ({ videoId }: VideoLinkProps) => {
  const url = `https://www.youtube.com/watch?v=${videoId}`;
  return (
    <a href={url} target="_blank" rel="noreferrer">
      {url}
    </a>
  );
};

export default VideoLink;
